<script setup>
const props = defineProps({
  email: {
    type: String,
    required: true,
  },
  hasError: {
    type: Boolean,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([ 'click' ]);
</script>

<template>
  <div class="invitation-tag" :class="{ 'invitation-tag-error': hasError, 'invitation-tag-selected': selected }">
    {{ props.email }} <button class="closing-btn" @click.prevent="emit('click')" />
  </div>
</template>
